{
  "intro": "How CloudServer reaches Hetzner for this project: the token, what it allows, and when the catalogue was last copied.",
  "provider": "Provider",
  "permission": "Permission",
  "permissionHint": "Read & write lets CloudServer change resources; with read only, actions are disabled.",
  "catalogueHint": "Regions, server types, images and prices are copied on connect and every six hours.",
  "problem": {
    "active": "The last request failed",
    "failing": "Hetzner did not answer. CloudServer keeps trying; your resources keep running.",
    "revoked": "Hetzner rejected the token. Generate a new one in the project and replace it here."
  },
  "replace": "Replace",
  "replaceLead": "Paste a new token of the same Hetzner project. The old one stops being used at once.",
  "tokenReplaced": "Token replaced",
  "rename": "Rename project",
  "dangerTitle": "Remove project",
  "dangerLead": "Only affects CloudServer, never the resources at Hetzner.",
  "forgetLead": "Forgets the token and the stored data. To stop paying for resources, delete them before removing the project.",
  "adminOnly": "Only administrators replace the token, rename or remove a project."
}
